import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  name: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-add-currency-dialog',
  templateUrl: 'add-currency-dialog.component.html',
  styleUrls: ['add-currency-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AddCurrencyDialogComponent {
  errorMessage: string;
  onAddCallback: ((code: string) => void) | null = null;

  constructor(
    public dialogRef: MatDialogRef<AddCurrencyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.errorMessage = data.errorMessage || '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onInputChange(event: any): void {
    if (this.data.name) {
      this.data.name = this.data.name.toUpperCase();
    }
  }

  onAddClick(): void {
    if (this.onAddCallback && this.data.name && this.data.name.length === 3) {
      this.onAddCallback(this.data.name);
    }
  }
}

